module.exports = __webpack_public_path__ + "img/bg-app.19bafc41.jpg";